import React from "react";
import {Box,Stack} from "@mui/material";
import styled from "@emotion/styled";
import PayLoomLogo from "../PayLoomLogo";
import { tokens, displayFont } from "../../theme";

// On the plum ground the headline takes blush and the supporting line steps
// back to muted-dark, which is the reversed pairing the book specifies. Pure
// white is never the text colour on plum.
// Module scope, for the same reason as FlexContainer in ./index.js: a styled()
// call in a render body is a new component type each pass, which remounts.
const TextBox = styled(Box)({
  color: tokens.surface,
  wordWrap: "break-word",
});

const Banner = () => {
  return (
    <Stack 
    width="100%" 
    height="100%" 
    paddingInline="2.71rem" 
    className="login-background-image"
    alignItems="start"
    justifyContent="center"
    spacing="1.875rem"
  >
      <Box sx={{marginBottom: "2.5rem"}}>
             <PayLoomLogo size={40} variant="reversed" />
      </Box>
      <TextBox
        fontFamily={displayFont}
        fontWeight={700}
        fontSize={"1.75rem"}
        lineHeight={1.2}
      >
          Streamline Your Workforce Management Effortlessly!
      </TextBox>
      <TextBox
        fontSize={"1rem"}
        lineHeight={1.7}
        sx={{ color: tokens.mutedDark }}
        >
         Seamless Global Operations: Let Us Manage Compliance, Payroll, and Benefits While You Expand      </TextBox>
    </Stack>
  );
};

export default Banner;
